import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { CONTACT } from "@/i18n";
import { Mail, Phone, MapPin, Facebook } from "lucide-react";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-sage-900 text-bone/90 mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-2xl bg-ochre-500 text-white flex items-center justify-center font-display font-bold text-lg">AK</div>
            <div>
              <div className="font-display font-semibold text-white text-lg">{lang === "ar" ? CONTACT.brand_ar : CONTACT.brand_en}</div>
              <div className="text-xs opacity-70">{lang === "ar" ? CONTACT.city_ar : CONTACT.city_en}</div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed opacity-80">{t("footer.tagline")}</p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-ochre-400 font-semibold mb-4">{t("footer.quick")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/treatments" className="hover:text-white">{t("nav.treatments")}</Link></li>
            <li><Link to="/hospitals" className="hover:text-white">{t("nav.hospitals")}</Link></li>
            <li><Link to="/doctors" className="hover:text-white">{t("nav.doctors")}</Link></li>
            <li><Link to="/services" className="hover:text-white">{t("nav.services")}</Link></li>
            <li><Link to="/blog" className="hover:text-white">{t("nav.blog")}</Link></li>
            <li><Link to="/about" className="hover:text-white">{t("nav.about")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-ochre-400 font-semibold mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-ochre-400" /><a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-phone">{CONTACT.phone}</a></li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-ochre-400" /><a href={`mailto:${CONTACT.email}`} data-testid="footer-email">{CONTACT.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-ochre-400" />{lang === "ar" ? CONTACT.city_ar : CONTACT.city_en}</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-ochre-400 font-semibold mb-4">{t("footer.follow")}</div>
          <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-2 rounded-full border border-bone/20 px-4 py-2 hover:bg-bone/10">
            <Facebook className="h-4 w-4" /> Facebook
          </a>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between text-xs opacity-70">
          <div>© {year} {lang === "ar" ? CONTACT.brand_ar : CONTACT.brand_en}. {t("footer.rights")}</div>
          <div className="mt-2 sm:mt-0"><Link to="/admin/login" className="hover:text-white">Admin</Link></div>
        </div>
      </div>
    </footer>
  );
}
